import {OverlayContainer} from "../misc/ImageViewer";
import {useAppDispatch, useAppSelector} from "../../hooks";
import styled from "styled-components";
import {setBackTableFilter, setSchemaManagePageArchiveOpen} from "../../features/schemaManageSlice";
import React, {useEffect, useState} from "react";
import {schemas} from "../../config";
import Loader from "../Loader";
import moment from "moment";
import FileEntry from "./archive/FileEntry";
import {useFadeIn} from "../hooks/useFadeIn";
import {apiFetch} from "../util";

export interface ArchiveFileEntry {
    name: string,
    type: 'file' | 'dir',
    mtime: number
}

export default function ArchiveViewer() {

    const selectedFacet = useAppSelector(state => state.schemaManage.selectedFacet);
    const mode = useAppSelector(state => state.schemaManage.back.mode);
    const projectName = useAppSelector(state => state.project.name);
    const selectedTable = useAppSelector(state => state.schemaManage.back.selectedTable);
    const dispatch = useAppDispatch();

    const [isLoading, setIsLoading] = useState(true);
    const [createCopy, setCreateCopy] = useState(true);

    const [entries, setEntries] = useState<ArchiveFileEntry[]>([]);

    const schema = schemas[projectName]

    const query = `project=${projectName}&type=table&entryKey=${selectedTable}`;

    const removeEntry = (eName: string) => setEntries(prevState => prevState.filter(e => e.name !== eName))

    useEffect(() => {
        if (!isLoading)
            return
        apiFetch(`${schema.backend}/astra/getArchiveEntries.php?${query}`)
            .then(({error, body}) => {
                if(!error)
                    setEntries(body.data)
                setIsLoading(false)
        })
    }, [isLoading, query, schema.backend])

    const css = useFadeIn();

    return <OverlayContainer $isVisible onClick={() => dispatch(setSchemaManagePageArchiveOpen(false))}>
        <Container onClick={(e: { stopPropagation: () => void; }) => e.stopPropagation()}>
            {/*{isLoading && <div className="loader">*/}
            {/*    <Loader/>*/}
            {/*</div>}*/}
            <div className="entries" style={css}>
                {entries.map(e => <FileEntry entry={e} projectName={projectName} backend={schema.backend}
                                             entryType={"table"}
                                             createCopy={createCopy}
                                             removeEntry={removeEntry}
                                             entryKey={selectedTable!} key={e.name}/>)}
            </div>
            <div className="check">
                <label>Створити копію поточної схеми при відновленні</label>
                <input type="checkbox" checked={createCopy} onChange={e => setCreateCopy(e.target.checked)}/>
            </div>
            <div className={'controls'}>

                <button className="close btn-cmn" onClick={() => dispatch(setSchemaManagePageArchiveOpen(false))}>
                    ❌
                </button>
            </div>
        </Container>

    </OverlayContainer>
}

const Container = styled.div`
  //height: 100%;
  max-height: calc(98vh - var(--header-height));
  background-color: var(--table-row-odd-bg-color);
  padding: .5rem;
  border-radius: .5rem;
  max-width: 90vw;
  min-width: 340px;
  width: 340px;
  max-width: 370px;
  min-height: 50vh;
  overflow-y: auto;
  display: flex;
  flex-flow: column;
  gap: .5rem;


  .controls {
    display: flex;
    justify-content: end;
    gap: .5rem;
  }

  .check {
    display: flex;
    margin-top: auto;
    gap: .5rem;
  }

  & .entries {
    display: flex;
    flex-flow: column;
    gap: .5rem;
    justify-content: center;
  }

  .loader {
    width: 100%;
    height: 500px;
  }
`
